import React, { useState, useEffect, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import axios from 'axios';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { Paginator } from 'primereact/paginator';
import { Link } from "react-router-dom";
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { useHistory } from 'react-router-dom';
import * as Designations from '../../enums/Designations';
import * as Travelmodes from '../../enums/Travelmodes';
import { MultiSelect } from 'primereact/multiselect';
import exportData from "../../services/exportToExcelService";
import { Toolbar } from "primereact/toolbar";
import * as Genders from '../../enums/Genders';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from "primereact/dropdown";
 import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";

const TicketsToBeRebook = () => {

    // Hooks
    const [participantlist, setParticipantlist] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false); const [rowdataid, setRowDataId] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory();
    const [boardingcityfilter, setboardingcityfilter] = useState(null);
    const [fullName, setfullName] = useState(null)
    const [hospitalNamefilter, sethospitalNamefilter] = useState(null);
    const [companyNameFilter, setcompanyNameFilter] = useState(null);
    const [filterEmail, setFilterEmail] = useState(null);
    const [filterMobileNo, setFilterMobileNo] = useState(null);
    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: 1,
        Designationfilter: null,
        Toeventcityfilter: null,
        Fromeventcityfilter: null,
        Genderfilter: null,
    }); // For Sorting And Pagination Purpose
    const [enableFilter, setEnableFilter] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [isExportExcel, setIsExportExcel] = useState(false);
    const [Cityfilter, setCityfilter] = useState(null);
    const [Statefilter, setStatefilter] = useState(null);
    const [Countryfilter, setCountryfilter] = useState(null);
    const [SerialNumber, setSerialNumber] = useState(null);
    const [filterDialog, setFilterDialog] = useState(false);

    useEffect(() => {
        getparticipantlist();
    }, [])

    // Get All Participants
    const getparticipantlist = (isExportExcel = false, event) => {
        setIsLoading(true);
        if (!isExportExcel) setParticipantlist([]);
        axios.post('/api/Participant/GetAll', {
            CompanyFilter: '',
            registrationStatus: 'APPROVED',
            InFlightBookingStatus: 'TO BE REBOOK',
            OutFlightBookingStatus: 'TO BE REBOOK',
            paginationRequired: !isExportExcel,
            SortDirection: lazyState.current.sortOrder,
            PageSize: lazyState.current.rows,
            CurrentPageNumber: event && event.rows ? ((event.first / event.rows) + 1) : lazyState.current.page,
            SortField: event && event.sortField ? event.sortField : "Firstname",
            FullName: fullName ? fullName : null,
            Email: filterEmail ? filterEmail : null,
            MobileNo: filterMobileNo ? filterMobileNo : null,
            Designation: lazyState.current.Designationfilter ? lazyState.current.Designationfilter.name : null,
            Gender: lazyState.current.Genderfilter ? lazyState.current.Genderfilter.name : null,
            ToEventCity: lazyState.current.Toeventcityfilter ? lazyState.current.Toeventcityfilter.code : null,
            FromEventCity: lazyState.current.Fromeventcityfilter ? lazyState.current.Fromeventcityfilter.code : null,
            SerialNumber: lazyState.current.serialnumber ? lazyState.current.serialnumber.trim() : null,
            City: Cityfilter ? Cityfilter : null,
            State: Statefilter ? Statefilter : null,
            Country: Countryfilter ? Countryfilter : null,
            BoardingCity: boardingcityfilter ? boardingcityfilter : null,
            HospitalName: hospitalNamefilter ? hospitalNamefilter : null
        }).then(Response => {
            if (!isExportExcel) setParticipantlist([]);
            let tempData = [];
            for (let dataObj of Response.data.data) {
                // Pass body data in excelsheets.
                let allExcelData;
                let excelcolumnData = {
                    Id: dataObj.id,
                    Name: dataObj.fullName,
                    Email: dataObj.email,
                    MobileNo: dataObj.mobileNo,
                    BoardingCity: dataObj.boardingcityname,
                }
                if (selectedColumns.length > 0) {
                    for (let selectedColumn of selectedColumns) {
                        let fieldName = selectedColumn.field;
                        let headerName = selectedColumn.header;
                        excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] }
                    }
                    tempData.push(excelcolumnData);
                } else {
                    allExcelData = {
                        Id: dataObj.id,
                        Name: dataObj.fullName,
                        Email: dataObj.email,
                        MobileNo: dataObj.mobileNo,
                        BoardingCity: dataObj.boardingcityname,
                    }
                    tempData.push(allExcelData);
                }
            }
            if (isExportExcel) {
                exportData(tempData, 'TicketsToBeRebook');
                setIsLoading(false);
                return false;
            }
            setTotalRecords(Response.data.totalRecords);
            setParticipantlist(Response.data.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
        });
    };

    const SerialNumberFilterTemplate = () => {
        return <InputText id="serialnumber" value={SerialNumber} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "5rem" }} />;
    };

    const UserFilterTemplate = () => {
        return (
            <InputText id="fullName" required value={fullName} placeholder="Enter FirstName"
                onChange={(e) => setfullName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const BoardingCityFilterTemplate = () => {
        return (
            <InputText id="boardingcityname" required value={boardingcityfilter} placeholder="Enter BoardingCity"
                onChange={(e) => setboardingcityfilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const EmailFilterTemplate = () => {
        return (
            <InputText id="Email" required value={filterEmail} placeholder="Enter Email"
                onChange={(e) => setFilterEmail(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const MobileFilterTemplate = () => {
        return (
            <InputText id="Email" required value={filterMobileNo} placeholder="Enter Mobile No."
                onChange={(e) => setFilterMobileNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const UserFilterOnEnter = (e) => {
        if (e.key == "Enter") {
            setIsLoading(true);
            getparticipantlist(isExportExcel);
            setIsLoading(false);
        }
    };


    const DesignationFilterTemplate = () => {
        return (
            <Dropdown value={lazyState.current.Designationfilter} options={Designations.Designation} optionLabel="name" showClear onChange={(e) => { lazyState.current.Designationfilter = (e.target.value ? e.target.value : null); getparticipantlist(isExportExcel, { Designation: e.value }); e.preventDefault() }} placeholder="Select Designation" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const GenderFilterTemplate = () => {
        return (
            <Dropdown value={lazyState.current.Genderfilter} options={Genders.Gender} optionLabel="name" showClear onChange={(e) => { lazyState.current.Genderfilter = (e.target.value ? e.target.value : null); getparticipantlist(isExportExcel, { Gender: e.value }); e.preventDefault() }} placeholder="Select Gender" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const ToEventCityTemplate = () => {
        return (
            <Dropdown value={lazyState.current.Toeventcityfilter} options={Travelmodes.Travelmode} optionLabel="name" showClear onChange={(e) => { lazyState.current.Toeventcityfilter = (e.target.value ? e.target.value : null); getparticipantlist(isExportExcel, { ToEventCity: e.value }); e.preventDefault() }} placeholder="Select TravelMode " className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };


    const FromEventCityTemplate = () => {
        return (
            <Dropdown value={lazyState.current.Fromeventcityfilter} options={Travelmodes.Travelmode} optionLabel="name" showClear onChange={(e) => { lazyState.current.Fromeventcityfilter = (e.target.value ? e.target.value : null); getparticipantlist(isExportExcel, { FromEventCity: e.value }); e.preventDefault() }} placeholder="Select TravelMode" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const CityFilterTemplate = () => {
        return (
            <InputText id="city" required value={Cityfilter} placeholder="Enter City"
                onChange={(e) => setCityfilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const StateFilterTemplate = () => {
        return (
            <InputText id="state" required value={Statefilter} placeholder="Enter State"
                onChange={(e) => setStatefilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const CountryFilterTemplate = () => {
        return (
            <InputText id="country" required value={Countryfilter} placeholder="Enter Country"
                onChange={(e) => setCountryfilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };


    // For Sorting 
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(isExportExcel, lazyState.current);
    };

    //pagination
    const onBasicPageChange = (event) => {
        // const newPage = event.first / event.rows + 1;
        // if (newPage !== lazyState.current.first / lazyState.current.rows + 1) {
            setIsLoading(true);
            lazyState.current.sortField = lazyState.current.sortField;
            lazyState.current.sortOrder = lazyState.current.sortOrder;
            lazyState.current.first = event.first;
            lazyState.current.rows = event.rows;
            getparticipantlist(isExportExcel, lazyState.current);
            setIsLoading(false);
        // };
    }

    //Template for pagination
    const template2 = {
        layout: ' CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '19%', textAlign: 'center' }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            )
        }
    };

    const exportExcel = () => {
        getparticipantlist(true);
    };

    const removeFilter = () => {
        setfullName(null);
        setboardingcityfilter(null);
        sethospitalNamefilter(null);
        setFilterEmail(null);
        setFilterMobileNo(null);
        setCityfilter(null);
        setStatefilter(null);
        setCountryfilter(null);
        setSerialNumber(null);
        lazyState.current.Designationfilter = null;
        lazyState.current.Genderfilter = null;
        lazyState.current.Toeventcityfilter = null;
        lazyState.current.Fromeventcityfilter = null;
        lazyState.current.serialnumber = null;
        getparticipantlist(isExportExcel);
    };

    const SearchFilter = () => {
        lazyState.current.page = 1;
        lazyState.current.first = 0;
        lazyState.current.serialnumber = SerialNumber;
        getparticipantlist();
        setFilterDialog(false);
    };

    const filterDialogFooter = (
        <div className="filter-dialog-footer">
            <Button label="Clear Filter" icon="pi pi-filter-slash" className="p-button-outlined" onClick={() => { removeFilter(); setFilterDialog(false); }} />
            <Button label="Apply Filter" icon="pi pi-check" className="p-button-primary" onClick={() => SearchFilter()} />
        </div>
    );

    // Left Side Toolbar
    const leftToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-left">
                <h4 className="headerfont m-auto mr-2">Count : {totalRecords}</h4>
            </div>
        );
    };

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-right">
                <Button label="Filter" icon="pi pi-filter" className="p-button-outlined mr-2 mobile-only-btn" onClick={() => setFilterDialog(true)} />
                <Button disabled={!fullName && !boardingcityfilter && !hospitalNamefilter && !filterEmail && !filterMobileNo && !Cityfilter && !Statefilter && !Countryfilter && !SerialNumber && !lazyState.current.Designationfilter && !lazyState.current.Genderfilter && !lazyState.current.Toeventcityfilter && !lazyState.current.Fromeventcityfilter}
                    icon="pi pi-filter-slash" className="mr-2" onClick={() => removeFilter()} tooltip="Reset Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} outlined></Button>
                <div className="my-2 desktop-only-btn">{header}</div>
                <Button disabled={!(participantlist != null && participantlist.length > 0)} tooltip="Export Excel" tooltipOptions={{ position: "bottom", className: "showtooltip" }} onClick={() => { exportExcel(); }} icon="pi pi-file-excel" className="mr-2" outlined />
            </div>
        )
    };

    //#region Method for Column toggle
    const hidecolumns = [
        { field: "designation", header: "Designation" },
        { field: "gender", header: "Gender" },
        { field: "cityname", header: "City" },
        { field: "statename", header: "State" },
        { field: "countryname", header: "Country" },
        { field: "travelmode_Inbound", header: "Travel In Bound" },
        { field: "travelmode_Outbound", header: "Travel Out Bound" }
    ];

    const onColumnToggle = (event) => {
        let selectedColumns = event.value;
        let orderedSelectedColumns = hidecolumns.filter(col => selectedColumns.some(sCol => sCol.field === col.field));
        setSelectedColumns(orderedSelectedColumns);
    };

    const header = (
        <div style={{ textAlign: 'left', marginRight: '10px' }}>
            <MultiSelect className="more-columns-multiselect" value={selectedColumns} options={hidecolumns} optionLabel="header" placeholder="More Columns" onChange={onColumnToggle} display="chip" />
        </div>
    );

    const hideColumnsFilterTemplate = (column) => {
        switch (column) {
            case "Designation":
                return DesignationFilterTemplate;
            case "Gender":
                return GenderFilterTemplate;
            case "City":
                return CityFilterTemplate;
            case "State":
                return StateFilterTemplate;
            case "Travel In Bound":
                return ToEventCityTemplate;
            case "Travel Out Bound":
                return FromEventCityTemplate;
            case "Country":
                return CountryFilterTemplate;
        }
    };

    const sortColumn = {
        "Designation": 'Designation',
        "cityname": 'cityname',
        "Statename": 'Statename',
        "Countryname": 'Countryname',
        "Travel In Bound": 'Travelmode_Inbound',
        "Travel Out Bound": 'Travelmode_Outbound',
        "Gender": 'Gender',
    };

    const hidecolumnComponents = selectedColumns.map(col => {
        return <Column key={col.field} field={col.field} header={col.header} sortable headerStyle={{ width: '14%', minWidth: '10rem' }} sortField={sortColumn[col.header]}
            filter showFilterMenu={false} filterElement={hideColumnsFilterTemplate(col.header)} />;
    });
    //#endregion

    const ButtonMailto = (rowData) => {
        return (
            <Link className="linkcolors"
                to='#'
                onClick={(e) => {
                    window.location.href = `mailto:${rowData.email}`;
                    e.preventDefault();
                }}
            >{rowData.email}
            </Link>
        );
    };

    const ButtonPhoneto = (rowData) => {
        return (
            <Link className="linkcolors"
                to='#'
                onClick={(e) => {
                    window.location.href = `tel:${rowData.mobileNo}`;
                    e.preventDefault();
                }}
            >{rowData.mobileNo}
            </Link>
        );
    };

    return (
        <div className="trico-Grid">
            {isLoading ? <LoadingSpinner /> :
                (
                    <>
                        <div className="p-col">
                            <div className="card">
                                <Toast ref={toast} />
                                <h5 className="headerfont"><span><i className="fa fa-solid fa-ticket mr-2"></i>Tickets to be Rebook</span></h5>
                                <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3"></Toolbar>
                                <div className="attendee-status-desktop-table">
                                    <DataTable size="small" lazy rows={lazyState.current.rows}
                                        onSort={onSort} sortField={lazyState.current.sortField} sortOrder={lazyState.current.sortOrder}
                                        removableSort stripedRows ref={dt} value={participantlist} selection={participantlist} onSelectionChange={(e) => setParticipantlist(e.value)}
                                        dataKey="Id" className="datatable-responsive" responsiveLayout="scroll" filterDisplay="row">
                                        <Column alignFrozen="left" field="serialNumber" header="Id" sortField="SerialNumber" sortable frozen headerStyle={{ width: "3%", minWidth: "5rem" }} filter showFilterMenu={false} filterElement={SerialNumberFilterTemplate} showClearButton></Column>
                                        <Column frozen className="font-bold" sortField="Firstname" field="fullName" header="Name of Certificate/Ticket" sortable headerStyle={{ width: '18%', minWidth: '18rem' }} filter showFilterMenu={false} filterElement={UserFilterTemplate} showClearButton></Column>
                                        <Column body={ButtonMailto} sortField="Email" field="email" header="Email" sortable headerStyle={{ width: '18%', minWidth: '18rem' }} filter showFilterMenu={false} filterElement={EmailFilterTemplate} showClearButton></Column>
                                        <Column body={ButtonPhoneto} sortField="MobileNo" field="mobileNo" header="Mobile No" sortable headerStyle={{ width: '18%', minWidth: '18rem' }} filter showFilterMenu={false} filterElement={MobileFilterTemplate} showClearButton></Column>
                                        <Column field="boardingcityname" sortField="boardingcityname" header="Boarding City" sortable headerStyle={{ width: '18%', minWidth: '18rem' }} filter showFilterMenu={false} filterElement={BoardingCityFilterTemplate} showClearButton></Column>
                                        {hidecolumnComponents}
                                    </DataTable>
                                </div>
                                <div className="attendee-status-mobile-cards">
                                    {participantlist && participantlist.length > 0 ? (
                                        <div className="attendee-card-grid">
                                            {participantlist.map((row, idx) => (
                                                <div className="attendee-mobile-card" key={row.id || idx}>
                                                    <div className="attendee-card-top">
                                                        <span className="attendee-card-id">#{row.serialNumber || (idx + 1)}</span>
                                                        <div className="attendee-card-badges">
                                                            {row.designation && <span className="designation-pill">{row.designation}</span>}
                                                            {row.gender && <span className="batch-tag">{row.gender}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="attendee-card-name">
                                                        {row.fullName}
                                                    </div>
                                                    <div className="attendee-card-details">
                                                        {row.email && (
                                                            <div className="attendee-detail-item">
                                                                <span className="detail-label"><i className="pi pi-envelope mr-1"></i>Email:</span>
                                                                <span className="detail-value">{ButtonMailto(row)}</span>
                                                            </div>
                                                        )}
                                                        {row.mobileNo && (
                                                            <div className="attendee-detail-item">
                                                                <span className="detail-label"><i className="pi pi-phone mr-1"></i>Mobile:</span>
                                                                <span className="detail-value">{ButtonPhoneto(row)}</span>
                                                            </div>
                                                        )}
                                                        {row.boardingcityname && (
                                                            <div className="attendee-detail-item">
                                                                <span className="detail-label"><i className="pi pi-map-marker mr-1"></i>Boarding City:</span>
                                                                <span className="detail-value">{row.boardingcityname}</span>
                                                            </div>
                                                        )}
                                                        {(row.cityname || row.statename || row.countryname) && (
                                                            <div className="attendee-detail-item">
                                                                <span className="detail-label"><i className="pi pi-globe mr-1"></i>Location:</span>
                                                                <span className="detail-value">{[row.cityname, row.statename, row.countryname].filter(Boolean).join(', ')}</span>
                                                            </div>
                                                        )}
                                                        {row.travelmode_Inbound && (
                                                            <div className="attendee-detail-item">
                                                                <span className="detail-label"><i className="pi pi-arrow-right mr-1"></i>Inbound Travel:</span>
                                                                <span className="detail-value">{row.travelmode_Inbound}</span>
                                                            </div>
                                                        )}
                                                        {row.travelmode_Outbound && (
                                                            <div className="attendee-detail-item">
                                                                <span className="detail-label"><i className="pi pi-arrow-left mr-1"></i>Outbound Travel:</span>
                                                                <span className="detail-value">{row.travelmode_Outbound}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="p-text-center p-p-4" style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>
                                            No records found
                                        </div>
                                    )}
                                </div>
                                <Paginator className='justify-content-end admin-paginator' first={lazyState.current.first} rows={lazyState.current.rows} totalRecords={totalRecords} template={template2} rowsPerPageOptions={RowsPerPageDropdown} onPageChange={onBasicPageChange} ></Paginator>
                            </div>
                        </div>
                        <Dialog visible={filterDialog} style={{ width: '90vw', maxWidth: '600px' }} header="Filter Tickets" modal className="p-fluid admin-dialog attendee-filter-dialog" footer={filterDialogFooter} onHide={() => setFilterDialog(false)}>
                            <div className="filter-dialog-grid">
                                <div className="filter-field-item">
                                    <label htmlFor="m_serialNumber">Sr No.</label>
                                    <InputText id="m_serialNumber" value={SerialNumber || ''} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_fullName">Name</label>
                                    <InputText id="m_fullName" value={fullName || ''} placeholder="Enter Name" onChange={(e) => setfullName(e.target.value)} />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_email">Email</label>
                                    <InputText id="m_email" value={filterEmail || ''} placeholder="Enter Email" onChange={(e) => setFilterEmail(e.target.value)} />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_mobile">Mobile No.</label>
                                    <InputText id="m_mobile" value={filterMobileNo || ''} placeholder="Enter Mobile No." onChange={(e) => setFilterMobileNo(e.target.value)} />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_boardingcity">Boarding City</label>
                                    <InputText id="m_boardingcity" value={boardingcityfilter || ''} placeholder="Enter Boarding City" onChange={(e) => setboardingcityfilter(e.target.value)} />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_designation">Designation</label>
                                    <Dropdown id="m_designation" value={lazyState.current.Designationfilter} options={Designations.Designation} optionLabel="name" showClear onChange={(e) => { lazyState.current.Designationfilter = e.value || null; }} placeholder="Select Designation" />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_gender">Gender</label>
                                    <Dropdown id="m_gender" value={lazyState.current.Genderfilter} options={Genders.Gender} optionLabel="name" showClear onChange={(e) => { lazyState.current.Genderfilter = e.value || null; }} placeholder="Select Gender" />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_city">City</label>
                                    <InputText id="m_city" value={Cityfilter || ''} placeholder="Enter City" onChange={(e) => setCityfilter(e.target.value)} />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_state">State</label>
                                    <InputText id="m_state" value={Statefilter || ''} placeholder="Enter State" onChange={(e) => setStatefilter(e.target.value)} />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_country">Country</label>
                                    <InputText id="m_country" value={Countryfilter || ''} placeholder="Enter Country" onChange={(e) => setCountryfilter(e.target.value)} />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_toevent">Travel In Bound</label>
                                    <Dropdown id="m_toevent" value={lazyState.current.Toeventcityfilter} options={Travelmodes.Travelmode} optionLabel="name" showClear onChange={(e) => { lazyState.current.Toeventcityfilter = e.value || null; }} placeholder="Select Travel Mode" />
                                </div>
                                <div className="filter-field-item">
                                    <label htmlFor="m_fromevent">Travel Out Bound</label>
                                    <Dropdown id="m_fromevent" value={lazyState.current.Fromeventcityfilter} options={Travelmodes.Travelmode} optionLabel="name" showClear onChange={(e) => { lazyState.current.Fromeventcityfilter = e.value || null; }} placeholder="Select Travel Mode" />
                                </div>
                            </div>
                        </Dialog>
                    </>
                )
            }
        </div>
    )
}
export default TicketsToBeRebook;